import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import type { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  BulkSelectComponent,
  ButtonComponent,
  FormFieldComponent,
  GroupComponent,
  IconButtonComponent,
  IconComponent,
  InputComponent,
  PaginationComponent,
  PaginationCounterComponent,
} from '@core/user-interface-legacy';
import { LifeCycle } from '@core/utils-legacy';

@Component({
  selector: 'rt-departments-toolbar',
  styleUrls: ['./departments-toolbar.component.less'],
  templateUrl: './departments-toolbar.component.html',
  imports: [
    BulkSelectComponent,
    ButtonComponent,
    CommonModule,
    FormFieldComponent,
    GroupComponent,
    IconButtonComponent,
    IconComponent,
    InputComponent,
    PaginationComponent,
    PaginationCounterComponent,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  host: {
    '[class.active]': 'selectedCount > 0',
  },
})
export class DepartmentsToolbarComponent {
  @Input() public canManage: boolean = false;
  @Input() public query: string;
  @Input() public bulkActionPending: boolean = false;
  @Input() public allSelected: boolean = false;
  @Input() public selectedCount: number;
  @Input() public viewSelectedCount: number;
  @Input() public viewCount: number;
  @Input() public totalCount: number;

  @Input()
  public pagination: {
    page: number;
    pagesCount: number;
    limit: number;
  } = {
    page: 1,
    pagesCount: 1,
    limit: 30,
  };

  public queryChange = output<string>();
  public createNew = output<void>();
  public bulkMerge = output<void>();
  public bulkDelete = output<void>();
  public pageChange = output<number>();
  public toggleSelectAllOnPage = output<boolean>();
  public clearSelection = output<void>();

  public queryControl: UntypedFormControl = new UntypedFormControl(null);

  public get pageItemsEnd(): number {
    return Math.min(this.pagination.page * this.pagination.limit, this.totalCount);
  }

  public get pageItemsStart(): number {
    return (this.pagination.page - 1) * this.pagination.limit + 1;
  }

  @LifeCycle('onDestroy')
  private ngOnDestroy$: Subject<void>;

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    this.queryControl.valueChanges.pipe(takeUntil(this.ngOnDestroy$)).subscribe(value => {
      this.queryChange.emit(value);
      this.cdRef.detectChanges();
    });
  }
}
